// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"19d73724fe40c7a0","820":"a9a02839079d4f96","888":"88286516073588ce"}[chunkId] + ".css";
};